const ROLES = {
  USER: 'ROLE_USER',
  ADMIN: 'ROLE_ADMIN',
};

export { ROLES }; // eslint-disable-line import/prefer-default-export



// WEBPACK FOOTER //
// ./src/config/roles.config.js